const COLORS_ODD = {
  2: 1,
  3: 2,
  5: 3,
  50: 0,
};

const COLORS = {
  2: 'blue',
  5: 'green',
  3: 'red',
  50: 'yellow',
};

Object.freeze(COLORS_ODD);
Object.freeze(COLORS);

export { COLORS_ODD, COLORS };
